import * as React from "react"

export const LockFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    fill="none"
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11.885 43q-1.175 0-2.03-.855T9 40.115V20.108q0-1.19.855-2.038t2.03-.847h3.48v-4.588q0-3.595 2.522-6.115T24.008 4t6.112 2.52 2.516 6.115v4.588h3.48q1.175 0 2.03.848.855.847.855 2.037v20.007q0 1.175-.855 2.03t-2.03.855zm12.124-9.5a3.28 3.28 0 0 0 2.389-.977q.99-.976.99-2.35 0-1.327-.998-2.388-1-1.062-2.399-1.062t-2.389 1.062q-.99 1.061-.99 2.413t.999 2.327a3.3 3.3 0 0 0 2.398.975m-6.375-16.277h12.732v-4.588q0-2.652-1.855-4.509-1.854-1.856-4.504-1.856t-4.511 1.856-1.861 4.509z"
    ></path>
  </svg>
)
